import React, {createContext, useContext, useEffect, useState} from "react";
import {loadCartFromLocalStorage, removeCartItem, updateCartItem} from "../utils/cart";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [cartItems, setCartItems] = useState(loadCartFromLocalStorage());
    useEffect(() => {
        setCartItems(loadCartFromLocalStorage());
    }, []);

    const openCart = () => setIsCartOpen(true);
    const closeCart = () => setIsCartOpen(false);

    const getNumberOfItemsInCart = () => {
        return cartItems.reduce((acc, curr) => acc + curr.quantity, 0)
    }

    const isCartEmpty = () => cartItems.length === 0;

    const updateQuantity = (product, amount) => {
        const itemInCart = cartItems.find((item) => item.id === product?.id)
        if (itemInCart) {
            const updatedItems = cartItems.map((item) =>
                item.id === product?.id
                    ? {...item, quantity: Math.max(1, item.quantity + amount)}
                    : item
            )
            setCartItems(updatedItems)
        } else {
            setCartItems([...cartItems, {...product, quantity: amount}]);
        }
        updateCartItem(product, amount);
    };

    const removeFromCart = (productId) => {
        const updatedItems = cartItems.filter((item) => item.id !== productId);
        setCartItems(updatedItems);
        removeCartItem(productId);
    };

    const calculateTotal = () => {
        return cartItems?.reduce((total, item) => total + item.price * item.quantity, 0);
    };

    return (
        <CartContext.Provider value={{
            cartItems,
            setCartItems,
            isCartOpen,
            openCart,
            closeCart,
            getNumberOfItemsInCart,
            isCartEmpty,
            updateQuantity,
            removeFromCart,
            calculateTotal
        }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
